const HTML_TAG = /<\/?[a-z][a-z0-9]*\b[^>]*>/i;

const ENTITIES: Record<string, string> = {
  amp: "&",
  lt: "<",
  gt: ">",
  quot: '"',
  apos: "'",
  nbsp: " ",
};

function decodeEntities(text: string) {
  return text.replace(/&(#x[0-9a-f]+|#\d+|[a-z]+);/gi, (match, entity) => {
    const lower = String(entity).toLowerCase();
    if (lower.startsWith("#x")) {
      return String.fromCodePoint(parseInt(lower.slice(2), 16));
    }
    if (lower.startsWith("#")) {
      return String.fromCodePoint(parseInt(lower.slice(1), 10));
    }
    return ENTITIES[lower] ?? match;
  });
}

/**
 * Turns legacy HTML-formatted text (e.g. `<p>…</p>` notes imported from
 * Rentman) into plain text. Text without HTML tags is returned unchanged.
 */
export function htmlToPlainText(text: string): string {
  if (!HTML_TAG.test(text)) return text;

  const withBreaks = text
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<\/(p|div|li|h[1-6])>\s*/gi, "\n")
    .replace(/<li\b[^>]*>/gi, "• ");

  return decodeEntities(withBreaks.replace(/<[^>]+>/g, ""))
    .replace(/[ \t]+\n/g, "\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
}
